export const NotificationMessageTypes = {
  INFO: 'info',
  ERROR: 'error',
  SUCCESS: 'success',
  WARN: 'warn'
}
